module.exports = __webpack_public_path__ + "static/media/rd-icons.dc6c0f7d.ttf";